<div
  class="modal-overlay"
  (click)="closeModal($event)"
  [formGroup]="todoForm"
  *ngIf="todoForm">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div>
        <h2 class="modal-title">{{ templateData?.name || 'Template Details' }}</h2>
      </div>
      <button
        mat-icon-button
        mat-dialog-close
        [matTooltip]="'TEMPLATE.SNACKBAR.CLOSE' | translate"
        [attr.aria-label]="'DIALOG.ARIA_LABEL.CLOSE' | translate"
        (click)="dialogRef.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="modal-content">
      <!-- Form Section -->
      <div class="form-section">
        <h3 class="section-title">
          {{ 'TEMPLATE_LIBRARY.DETAILS.TITLE' | translate }}
        </h3>
        <p class="section-subtitle">
          {{ 'TEMPLATE_LIBRARY.DETAILS.SUB_TITLE' | translate }}
          <strong>{{
            'TEMPLATE_LIBRARY.DETAILS.STROG.SUB_TITLE' | translate
          }}</strong
          >.
        </p>

        <div class="form-group">
          <label class="form-label">{{
            'TEMPLATE_LIBRARY.DETAILS.NAME_TEMPLATE' | translate
          }}</label>

          <input
            type="text"
            class="form-input"
            formControlName="name"
            [class.error]="name.invalid && name.touched"
            placeholder="Ingresa el nombre de la plantilla" />

          <div class="character-count">
            <span>{{ (name.value || '').length }}/512</span>
            <!-- Esta línea ahora está protegida por el *ngIf del div padre -->
            <span class="warning-icon" *ngIf="name.invalid && name.touched">⚠</span>
          </div>

          <div
            *ngIf="name.invalid && (name.dirty || name.touched)"
            class="invalid-parameters invalid-parameters--bodytext">
            <div *ngIf="name.hasError('required')">
              {{ 'TEMPLATE.NAME.REQUIRED' | translate }}
            </div>
            <div *ngIf="name.hasError('pattern')">
              {{ 'TEMPLATE.NAME.ERROR' | translate }}
            </div>
            <div *ngIf="name.hasError('containsAccents')">
              {{ 'TEMPLATE.NAME.ERROR.ACENTO' | translate }}
            </div>
            <div *ngIf="name.hasError('containsEnye')">
              {{ 'TEMPLATE.NAME.ERROR.LETRA' | translate }}
            </div>
            <div *ngIf="name.hasError('nameExists')">
              {{ 'TEMPLATE.NAME.EXISTS' | translate }}
            </div>
          </div>
        </div>

        <!-- Buttons Section -->
        <div class="buttons-section" *ngIf="templateData?.labelUrl">
          <h4 class="section-title">{{ 'TEMPLATE.LABEL.BUTTONS' | translate }}</h4>
          <div class="card-container">
            <div class="button-item">
              <!-- Reemplaza el emoji con un SVG para mejor control -->

              <mat-icon
                _ngcontent-hcr-c46=""
                class="mat-icon notranslate material-icons mat-icon-no-color button-icon"
                aria-hidden="true"
                role="img"
                style="vertical-align: middle; font-size: 20px">
                open_in_new
              </mat-icon>
              <span class="button-text">{{
                templateData?.labelUrl || 'View details'
              }}</span>
            </div>

            <div class="url-config">
              <div class="url-type">
                <label class="form-label">{{
                  'TEMPLATE_LIBRARY.MODAL_FORM.URL_TYPE_LABEL' | translate
                }}</label>
                <select class="select-field">
                  <option value="static">
                    {{
                      'TEMPLATE_LIBRARY.MODAL_FORM.URL_TYPE_STATIC_OPTION'
                        | translate
                    }}
                  </option>
                </select>
              </div>

              <div class="url-input">
                <label class="form-label">{{
                  'TEMPLATE_LIBRARY.MODAL_FORM.WEBSITE_URL_LABEL' | translate
                }}</label>
                <input
                  type="url"
                  class="form-input url-field"
                  formControlName="url"
                  [class.error]="url.invalid && url.touched"
                  placeholder="Ej: https://www.ejemplo.com/verificar" />
                <span class="character-limit"
                  >{{ (url.value || '').length }}/1000</span
                >
              </div>
            </div>

            <div
              *ngIf="url.invalid && url.touched"
              class="invalid-parameters"
              style="margin-top: 5px; display: block">
              <span *ngIf="url.errors?.required || url.errors?.urlBad">{{
                'TEMPLATE.BOTON.URL.ERROR' | translate
              }}</span>
              <span *ngIf="url.errors?.whatsappUrlBad">{{
                'TEMPLATE.BOTON.URL.WHATSAPP.ERROR' | translate
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview Section -->
      <div class="preview-section">
        <div class="preview-tabs">
          <button
            class="tab-button"
            [class.active]="activeTab === 'parameters'"
            (click)="activeTab = 'parameters'">
            {{ 'TEMPLATE_LIBRARY.MODAL_PREVIEW.PARAMETERS_TAB' | translate }}
          </button>
          <button
            class="tab-button"
            [class.active]="activeTab === 'example'"
            (click)="activeTab = 'example'">
            {{ 'TEMPLATE_LIBRARY.MODAL_PREVIEW.EXAMPLE_TAB' | translate }}
          </button>
        </div>

        <div class="preview-container">
          <div class="message-preview">
            <!-- Header Text -->
            <div class="message-header" *ngIf="templateData?.headerText">
              {{ templateData.headerText }}
            </div>

            <!-- Body Text -->
            <div class="message-body">
              <ng-container *ngIf="activeTab === 'example'; else parametersView">
                {{ getProcessedBodyText() }}
              </ng-container>

              <ng-template #parametersView>
                {{ templateData?.bodyText }}
              </ng-template>
            </div>

            <!-- Button -->
            <a class="message-button" *ngIf="templateData?.labelUrl">
              <!-- Ícono SVG para 'View details' -->
              <mat-icon
                _ngcontent-hcr-c46=""
                class="mat-icon notranslate material-icons mat-icon-no-color button-icon"
                aria-hidden="true"
                role="img"
                style="vertical-align: middle; font-size: 20px">
                open_in_new
              </mat-icon>
              <span>{{ templateData.labelUrl || 'View details' }}</span>
            </a>

            <!-- Timestamp -->
            <div class="message-time">
              {{ getCurrentTime() }}
            </div>
          </div>
        </div>

        <p class="preview-note" *ngIf="activeTab === 'parameters'">
          {{ 'TEMPLATE_LIBRARY.MODAL_PREVIEW.PARAMETERS_NOTE_PREFIX1' | translate }}
          <span ngNonBindable>{{}}</span>
          {{ 'TEMPLATE_LIBRARY.MODAL_PREVIEW.PARAMETERS_NOTE_SUFFIX2' | translate }}
        </p>
        <p class="preview-note" *ngIf="activeTab === 'example'">
          {{ 'TEMPLATE_LIBRARY.MODAL_PREVIEW.EXAMPLE_NOTE' | translate }}
        </p>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <div class="footer-left"></div>

      <div class="footer-right">
        <button
          mat-button
          (click)="customizeTemplate()"
          style="background-color: #2d323e; color: white">
          {{ 'TEMPLATE_LIBRARY.CUSTOMIZE.TEMPLATE' | translate }}
        </button>

        <button
          mat-raised-button
          color="accent"
          (click)="sendTemplate()"
          [disabled]="!todoForm.valid">
          {{ 'TEMPLATE_LIBRARY.MODAL_FORM.BUTTON_SEND' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
